export default [
  {
    name: 'Arial',
    value: 'Arial, Helvetica, sans-serif',
  },
  {
    name: 'WindSong',
    value: 'WindSong',
  },
  {
    name: 'Montserrat',
    value: '"Montserrat", sans-serif',
  },
  {
    name: 'Tahoma',
    value: 'Tahoma, sans-serif',
  },
  {
    name: 'Arial Black',
    value: 'Arial Black, Gadget, sans-serif',
  },
  {
    name: 'Brush Script MT',
    value: 'Brush Script MT, sans-serif',
  },
  {
    name: 'Comic Sans MS',
    value: 'Comic Sans MS, cursive, sans-serif',
  },
  // listado
  {
    name: 'Courier New',
    value: 'Courier New, Courier, monospace',
  },
  {
    name: 'Georgia',
    value: 'Georgia, serif',
  },
  {
    name: 'Helvetica',
    value: 'Helvetica, sans-serif',
  },
  {
    name: 'Impact',
    value: 'Lucida Sans Unicode, Lucida Grande, sans-serif',
  },
  {
    name: 'Lucida Sans Unicode',
    value: 'Comic Sans MS, cursive, sans-serif',
  },
  {
    name: 'Times New Roman',
    value: 'Times New Roman, Times, serif',
  },
  {
    name: 'Trebuchet MS',
    value: 'Trebuchet MS, Helvetica, sans-serif',
  },
  {
    name: 'Verdana',
    value: 'Verdana, Geneva, sans-serif',
  },
  {
    name: 'Nanum Gothic',
    value: '\'Nanum Gothic\', sans-serif',
  },
  {
    name: 'Didact Gothic',
    value: '\'Didact Gothic\', sans-serif',
  },
  {
    name: 'Baloo 2',
    value: '\'Baloo 2\', cursive',
  },
  {
    name: 'Italiana',
    value: '"Italiana", sans-serif',
  },
  {
    name: 'Lexend',
    value: '"Lexend", serif',
  },
  {
    name: 'DM Sans',
    value: '"DM Sans", serif',
  },
  {
    name: 'Inter',
    value: '"Inter", serif',
  },
  {
    name: 'Manrope',
    value: '"Manrope", serif',
  },
  {
    name: 'Poppins',
    value: '"Poppins", serif',
  },
  {
    name: 'Roboto',
    value: '"Roboto", serif',
  },
  {
    name: 'Ubuntu',
    value: '"Ubuntu", serif',
  },
  {
    name: 'Cinzel',
    value: '"Cinzel", serif',
  },
  {
    name: 'Poppins',
    value: '"Poppins", sans-serif',
  },
  {
    name: 'Noto-Serif',
    value: '"Noto Serif", serif',
  },
  {
    name: 'Inter',
    value: '"Inter", sans-serif',
  },
  {
    name: 'Inter-tight',
    value: '"Inter Tight", sans-serif',
  },
  {
    name: 'Roboto Slab',
    value: '"Roboto Slab", serif',
  },
  {
    name: 'Atkinson Hyperlegible',
    value: '"Atkinson Hyperlegible", sans-serif',
  },
  {
    name: 'Work Sans',
    value: '"Work Sans", sans-serif',
  },
  {
    name: 'Lato',
    value: '"Lato", sans-serif',
  },
  {
    name: 'Mona sans',
    value: '"Mona Sans", sans-serif',
  },
  {
    name: 'Clicker Script',
    value: '"Clicker Script", cursive',
  },
  {
    name: 'Playfair Display',
    value: '"Playfair Display", serif',
  },
  {
    name: 'Libertinus Sans',
    value: '"Libertinus Sans", sans-serif',
  },
  {
    name: 'Anton',
    value: '"Anton", sans-serif',
  },
  {
    name: 'Raleway',
    value: '"Raleway", sans-serif',
  },
  {
    name: 'Open Sans',
    value: '"Open Sans", sans-serif',
  },
  {
    name: 'Nunito Sans',
    value: '"Nunito Sans", sans-serif',
  },
  {
    name: 'Audiowide',
    value: '"Audiowide", sans-serif',
  },
  {
    name: 'JetBrains Mono',
    value: '"JetBrains Mono", monospace',
  },
  {
    name: 'Exo',
    value: '"Exo", sans-serif',
  },
  {
    name: 'Sintony',
    value: '"Sintony", sans-serif',
  },
];
